import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/core/components/ui/select";
import { dayjs } from "@/core/utils/date";
import { cn } from "@/core/utils/utils";

const getLastMonthLabel = () => {
  const lastMonth = dayjs().subtract(1, "month");
  const monthName = lastMonth.format("MMM");
  return `Last Month (${monthName})`;
};

export const FILTER_OPTIONS = [
  { label: "Last 30 Days", value: "last_thirty_days" },
  { label: getLastMonthLabel(), value: "last_month" },
  { label: "All Time", value: "all_time" },
] as const;

export type TimeframeValue = (typeof FILTER_OPTIONS)[number]["value"];

interface TimeframeFilterProps {
  className?: string;
  value: TimeframeValue;
  onChange: (value: TimeframeValue) => void;
}

export const TimeframeFilter = ({
  className,
  value,
  onChange,
}: TimeframeFilterProps) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className={cn("w-[200px]", className)}>
      <SelectValue placeholder="Select timeframe" />
    </SelectTrigger>
    <SelectContent>
      {FILTER_OPTIONS.map((option) => (
        <SelectItem key={option.value} value={option.value}>
          {option.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
